export default __webpack_public_path__ + "static/media/tab3.77d404eb.svg";